import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Wishlist from "@/pages/Wishlist";
import Cart from "@/pages/Cart";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Policy from "@/pages/Policy";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StoreProvider>
          <Toaster position="bottom-center" toastOptions={{ style: { fontFamily: "Manrope, sans-serif" } }} />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop collection="all" />} />
              <Route path="/dresses" element={<Shop collection="dresses" />} />
              <Route path="/new-arrivals" element={<Shop collection="new-arrivals" />} />
              <Route path="/sale" element={<Shop collection="sale" />} />
              <Route path="/collection/:handle" element={<Shop />} />
              <Route path="/product/:handle" element={<ProductDetail />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy" element={<Policy slug="privacy" />} />
              <Route path="/shipping" element={<Policy slug="shipping" />} />
              <Route path="/returns" element={<Policy slug="returns" />} />
              <Route path="/terms" element={<Policy slug="terms" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </StoreProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
